import { useState, useEffect, useCallback } from "react";
import Modal from "react-modal";
import { Button, Container, Stack } from "basis";
import { useConfigConstant } from "library/hooks/useConfig";
import { useSessionTimeout } from "library/hooks/sessionTimeout";
import { useAuthentication } from "library/hooks/auth/useAuthentication";
import { SvgInline } from "../SvgInline/SvgInline";
import modalStyles from "../Modal/modal.module.scss";
import styles from "./timeout-modal.module.scss";

export const TimeoutModal = ({ abort, setIsModalOpen }) => {
  const MODAL_DURATION = useConfigConstant(
    "SESSION_TIMEOUT_MODAL_DURATION_SEC",
  );
  const [seconds, setSeconds] = useState(MODAL_DURATION);
  const { logoutUser } = useAuthentication();
  const closeAndLogout = useCallback(() => {
    setIsModalOpen(false);
    logoutUser({ redirectTo: "logout" });
  }, [setIsModalOpen, logoutUser]);

  const stayLoggedIn = () => {
    setIsModalOpen(false);
    abort();
  };

  useEffect(() => {
    const timeout = setInterval(() => {
      setSeconds((sec) => {
        if (sec === 0) {
          closeAndLogout();
          return sec;
        }
        return sec - 1;
      });
    }, 1000);
    return () => clearInterval(timeout);
  }, [closeAndLogout, setSeconds]);

  return (
    <Modal
      isOpen
      onRequestClose={() => setIsModalOpen(false)}
      className={`${modalStyles.modal} ${styles.logoutModal}`}
      overlayClassName={modalStyles.overlay}
    >
      <SvgInline name="customer-service-waving" />
      <h1 className="h4">Your session is about to expire</h1>
      <div className={`subtitle02 ${styles.logoutMessage}`}>
        You will be logged out due to inactivity in{" "}
        <strong className={seconds <= 10 ? styles.countdownRed : ""}>
          {seconds} seconds
        </strong>
        .
      </div>
      <Container margin="8 0 0 0">
        <Stack
          direction="vertical"
          direction-sm="horizontal"
          gap="4 8"
          align="center"
        >
          <Button width="168" onClick={() => stayLoggedIn()}>
            Stay logged in
          </Button>
          <Button
            width="168"
            variant="secondary"
            onClick={() => closeAndLogout()}
          >
            Log out
          </Button>
        </Stack>
      </Container>
    </Modal>
  );
};

export const TimeoutModalHandler = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const abort = useSessionTimeout(setIsModalOpen);

  return isModalOpen ? (
    <TimeoutModal abort={abort} setIsModalOpen={setIsModalOpen} />
  ) : null;
};
